<template>
  <div class="record_wrap" @scroll="handleScroll" >
    <div class="record_item" v-for="(item, index) in data" :key="index" >
      <div class="record_left" >
        <div>{{ item.typeStr }}</div>
        <div>{{ item.createTime }}</div>
      </div>
      <div class="reduce_text" v-if="item.type == 2 || item.type == 4" >-{{ item.money }}</div>
      <div class="increase_text" v-else >+{{ item.money }}</div>
    </div>

    <van-empty description="暂无转账记录" v-if="data.length <= 0" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  getUserSugarMoneyHistoryByPage
} from '@/api/transfer'
export default {
  name: 'transferList',
  data() {
    return {
      page: 1,
      pageSize: 20,
      data: []
    }
  },
  methods: {
    handleScroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollTop + clientHeight >= scrollHeight - 50){
        this.page++
        this.getUserSugarMoneyHistoryByPage()
      }
    },
    getUserSugarMoneyHistoryByPage() {
      const { page, pageSize } = this
      getUserSugarMoneyHistoryByPage({ page, pageSize }).then(res => {
        if(res.success) {
          this.data = this.data.concat(res.data)
        }
      })
    }
  },
  mounted() {
    this.getUserSugarMoneyHistoryByPage()
  }
}
</script>
